import React, { useState, useContext, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

/* import utils */
import { NotifyContext } from "./../../../util/notify";
import { getDateByTimeZoneCba } from "./../../../util/functions";

/* import services */
import api from "./../../../services/api";
import upload from "./../../../services/s3";

/* import components */
import Input from "./../../../components/Form/Input";
import Editor from "./../../../components/Form/Editor";
import Select from "./../../../components/Form/Select";
import FileImage from "./../../../components/Form/FileImage";
import File from "./../../../components/Form/File";

import { CKEditor } from "@ckeditor/ckeditor5-react";

import SaveButton from "./../../../components/Form/Buttons/Save";
import CancelButton from "./../../../components/Form/Buttons/Cancel";

/* import styles  */
import { Container, Form } from "./styles";

export default function Update({ toggleTitles }) {
  const client_id = process.env.REACT_APP_CLIENT_ID;
  const site_id = process.env.REACT_APP_SITE_ID;

  toggleTitles("Notícias", "Editar uma notícia");
  const { notify } = useContext(NotifyContext);
  const { news_id } = useParams();
  const history = useHistory();

  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [content, setContent] = useState("");
  const [date, setDate] = useState("");
  const [is_active, setIs_active] = useState(true);
  const [covid, setCovid] = useState(false);
  const [image_path, setImage_path] = useState("");
  const [images, setImages] = useState([]);
  const [content_image_path, setContent_image_path] = useState("");
  const [content_images, setContent_images] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const [componentEditor, setComponentEditor] = useState();

  const uploadS3 = async () => {
    if (content_images.length > 0) {
      notify.show(true, "Fazendo upload da imagem para ser usada", "info");

      const imagesUpload = await upload(client_id, site_id, content_images, "ckeditor/");

      if (imagesUpload && imagesUpload[0].fileUrl) {
        await setContent_image_path(imagesUpload[0].fileUrl);
        await setModalOpen(true);
        notify.show(true, "Upload realizado com suscesso", "success");
      } else {
        notify.show(true, "Não foi possivel realizar o upload da imagem! Tente novamente.", "error");
        return;
      }
    }
  };

  const handleClear = event => {
    event.preventDefault();

    setTitle("");
    setSummary("");
    setContent("");
    componentEditor.setData("");
    setImage_path("");
    setCovid(false);
    setDate("");
    setIs_active(true);
    setContent_image_path("");
    setImages([]);
    setContent_images([]);

    notify.show(true, "Campos limpos", "info");
  };

  const handleSave = async e => {
    if (images.length <= 0) {
      notify.show(true, "Uma imagem é obrigatória", "info");
      return;
    }

    notify.show(true, "Salvando...", "info");

    const imagesUpload = await upload(client_id, site_id, images, "noticias/");
    let image;

    if (imagesUpload && imagesUpload[0].fileUrl) {
      image = imagesUpload[0].fileUrl;
    } else {
      notify.show(true, "Não foi possivel realizar o upload da imagem! Tente novamente.", "error");
      return;
    }

    try {
      await api.put(
        `/news/${news_id}`,
        { title, summary, content: componentEditor.getData(), date, covid, is_active, image_path: image },
        {
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
        },
      );
      notify.show(true, "Registro atualizado com ", "success");
      history.replace("/noticias");
    } catch (error) {
      console.log(error);
      notify.show(true, "Erro ao atualizado registro", "error");
    }
  };

  useEffect(() => {
    uploadS3();
  }, [content_images]);

  useEffect(() => {
    async function loadData() {
      try {
        const { data } = await api.get(`/news/${news_id}`);
        setTitle(data.title);
        setSummary(data.summary);
        setContent(data.content);
        setImage_path(data.image_path);
        setCovid(data.covid);
        setImages([{ file: data.image_path }]);
        setDate(getDateByTimeZoneCba(data.date, "yyyy'-'MM'-'dd"));
        setIs_active(data.is_active);
      } catch (error) {
        notify.show(true, "Erro ao consultar registro", "error");
        history.goBack();
      }
    }

    if (!news_id) {
      notify.show(true, "Erro ao consultar registro", "error");
      history.goBack();
    }

    loadData();
  }, []);

  return (
    <>
      <Container>
        <form>
          <Form>
            <Input
              id="title"
              name="title"
              label="Título (importante para o SEO)"
              tabIndex={1}
              type="text"
              initialValue={title}
              onChange={text => {
                setTitle(text);
              }}
              required={true}
              maxLength={59}
            />

            <Input
              id="summary"
              name="summary"
              label="Chamada/Resumo (importante para o SEO)"
              tabIndex={2}
              type="text"
              initialValue={summary}
              onChange={text => {
                setSummary(text);
              }}
              required={true}
              maxLength={160}
            />

            <Input
              id="date"
              name="date"
              label="Data da notícia"
              tabIndex={3}
              type="date"
              initialValue={date}
              onChange={text => {
                setDate(text);
              }}
              required={true}
            />

            <File
              id="image_path"
              initialFile={image_path}
              onChange={files => {
                setImages(files);
              }}
              label="Imagem da capa (800 x 600)"
              tabIndex={4}
              bg="#FFFFFF"
            />

            <Select
              id="is_active"
              name="is_active"
              label="Situção"
              tabIndex={5}
              initialValue={is_active}
              onChange={text => {
                setIs_active(text);
              }}
              options={[
                { value: true, text: "Ativa" },
                { value: false, text: "Inativa" },
              ]}
              multiple={false}
              required={true}
            />
            <Select
              id="covid"
              name="covid"
              label="Covid-19?"
              tabIndex={5}
              initialValue={covid}
              onChange={value => {
                setCovid(value);
              }}
              options={[
                { value: true, text: "Sim" },
                { value: false, text: "Não" },
              ]}
              multiple={false}
              required={true}
            />

            <FileImage
              id="content_image_path"
              initialFile={content_image_path}
              onChange={files => {
                setContent_images(files);
              }}
              label="Subir uma imagem para o servidor"
            />

            <Editor label="Conteúdo" id="content" initialValue={content} onInit={component => setComponentEditor(component)} />
          </Form>

          {/* <CancelButton {...{ id: "cancel", text: "Limpar", tabIndex: 10 }} onClick={event => handleClear(event)} /> */}
          <SaveButton
            type="button"
            {...{ id: "save", text: "Salvar", tabIndex: 9 }}
            onClick={() => {
              handleSave();
            }}
          />
        </form>
      </Container>

      <Dialog
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">Copiar imagem </DialogTitle>
        <DialogContent style={{ textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <img src={content_image_path} style={{ maxWidth: "400px" }} />
          <br />
          <label>Copie a imagem usando o botão direito no mouse</label>
          <label>Copie a imagem e cole no editor</label>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setModalOpen(false);
            }}
            color="secondary">
            Cancelar
          </Button>
          <Button
            tabIndex={107}
            color="primary"
            onClick={() => {
              setModalOpen(false);
            }}>
            Já copiei
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
